import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/springwater/share/top.png';
import _imports_1 from '../../assets/springwater/share/loading.png';
const _withScopeId = n => (_pushScopeId("data-v-0ae87434"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "share"
};
const _hoisted_2 = {
  class: "shareWarp",
  id: "shareWarp",
  ref: "shareWarp"
};
const _hoisted_3 = {
  class: "img"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "success"
}, null, -1));
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  class: "shareLogo"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  key: 2,
  class: "shareImg"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请长按图片保存或分享给好友", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请点击右上角分享给好友或朋友圈", -1));
const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = {
  key: 0,
  class: "loading"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "图片生成中，请稍候", -1));
const _hoisted_18 = [_hoisted_16, _hoisted_17];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $data.detail.img
  }, null, 8, _hoisted_4), _hoisted_5]), _createElementVNode("div", {
    class: "shareContent",
    innerHTML: $data.detail.description
  }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
    src: $data.logo
  }, null, 8, _hoisted_8)]), $data.showBtn ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "downLoad",
    ref: "downLoad",
    onClick: _cache[0] || (_cache[0] = $event => $options.drawCanvas('#shareWarp'))
  }, null, 512)) : _createCommentVNode("", true), $data.showBtn ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "shareBtn",
    ref: "shareBtn",
    onClick: _cache[1] || (_cache[1] = $event => $data.showShareShop = true)
  }, null, 512)) : _createCommentVNode("", true), $data.showShareImg ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("img", {
    src: $data.newSrc
  }, null, 8, _hoisted_10), _hoisted_11])) : _createCommentVNode("", true), $data.showShareShop ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "sharePop",
    onClick: _cache[2] || (_cache[2] = $event => $data.showShareShop = false)
  }, _hoisted_14)) : _createCommentVNode("", true)], 512), $data.showLoading ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18)) : _createCommentVNode("", true)]);
}